import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { createContext } from 'react';
import { loadable } from 'react-lazily/loadable';
import { Provider } from 'react-redux';
const { AppContext } = loadable(() => import('./AppContext'));
const debug = process.env.REACT_APP_DEBUG && false;
const { REACT_APP_PROJECT_CODE: projectCode } = process.env;
/**
 * https://react-redux.js.org/api/provider
 * https://github.com/reduxjs/react-redux/issues/1565
 */
export const systemContext = createContext(null);
/**
 * `systemContext` provider suppressed until typings and `createContext` understood better (2024 08 - would ideally like seperate store to capture system transactions etc.
 * currently using `react-redux` provider, plus some type assertions, `null` is still recieved by test component (Header)
 * docs are unclear on how to initialize (system)Context with state.
 *
 * this is attempting to make use of multiple stores, custom context in `react-redux`
 */
const Root = ({ store }) => {
    debug && console.log('Root rerendered and says appcode is', projectCode?.substring(0, 4));
    return (_jsx(Provider, { store: store, children: _jsx(AppContext, {}) }));
};
Root.propTypes = {
    store: PropTypes.object.isRequired,
};
export default Root;
